import styled from 'styled-components';
import Row from '../../../Common/Row';
import ReportIconImage from '../../../../images/report.svg';

export const FlexDiv = styled.div`
  padding: 12px 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Wrapper = styled(Row)`
  min-height: 80px;

  .showOnMouseOver {
    visibility: hidden;
  }

  &:hover {
    .redOnHover {
      background-color: var(--color-brand-primary-alt);
    }

    .greenOnHover {
      background-color: var(--color-status-success);
    }

    .primaryOnHover {
      background-color: var(--color-status-danger);
    }

    .showOnMouseOver {
      width: unset;
      visibility: visible;
    }
  }
`;

export const Placeholder = styled.div`
  padding: 12px 32px;
`;

const reportIconSize = '32px';

export const ReportIconSpacing = styled.div`
  width: ${reportIconSize};
  height: ${reportIconSize};
`;

export const ReportIconWrapper = styled.div`
  &:hover {
    .redOnHover {
      background-color: var(--color-brand-primary-alt);
    }

    .greenOnHover {
      background-color: var(--color-status-success);
    }

    .primaryOnHover {
      background-color: var(--color-status-danger);
    }
  }
`;

export const ReportIcon = styled(ReportIconSpacing)`
  background-color: var(--color-logan);
  mask: url(${ReportIconImage}) no-repeat center;
`;
